module.exports = __webpack_public_path__ + "img/dydx.dc08a058.svg";